export default {"src":"/newStatic/_next/static/media/bell.46ffc819.svg","height":21,"width":18};